import { Button, Input, InputAdornment, Tooltip } from '@mui/material';
import { ISupportCost } from '../index';
import { Line } from '../styles';
import UndoIcon from '@mui/icons-material/Undo';
import { newMoneyWithNegative, newMoney } from 'utils/newMoney';
import dayjs from 'dayjs';

interface FormTableLineProps {
  element: ISupportCost;
  onEditField: (id: number, field: keyof ISupportCost, value: any) => void;
  onRollback: (id: number) => void;
  isEdited: boolean;
}

export function FormTableLine({ element, onEditField, onRollback, isEdited }: FormTableLineProps) {
  const handleChange = (field: keyof ISupportCost, value: any) => {
    onEditField(element.id, field, value);
  };

  const total = (element.leaderCommission || 0) + (element.defaultCost || 0) + (element.costAdjustment || 0);
  const vehicle = element.supportDriver?.vehicle;
  const driverName = vehicle?.driver?.name || vehicle?.name || 'Não informado';
  const driverSurname = vehicle?.driver?.surname || '';
  const deliveryDate = (element.supportDriver as any)?.deliveryDate || 'Não informado';

  return (
    <Line
      className="bodyLine"
      style={{
        background: isEdited ? '#E8F2D2' : undefined,
        transition: 'background 0.2s, border 0.2s',
      }}
    >
      <td style={{ textAlign: 'left', paddingLeft: '29px' }}>{`${driverName} ${driverSurname}`}</td>
      <td>{vehicle?.licensePlate || 'Não informado'}</td>
      <td>{dayjs(deliveryDate).format('DD/MM/YYYY')}</td>
      <td>{vehicle?.transshipPoint?.name || vehicle?.distributionCenter || 'Não informado'}</td>
      <td>{element?.defaultCost ? `R$ ${newMoney.apply(element.defaultCost.toString())}` : 'Não informado'}</td>
      <td onClick={(e: any) => e.target?.children[0]?.focus()}>
        <div className="boxAmount">
          <Input
            type="text"
            value={newMoneyWithNegative.apply(element.costAdjustment)}
            onChange={e => handleChange('costAdjustment', newMoneyWithNegative.clean(e.target.value))}
            onFocus={e => e.target.select()}
            inputProps={{
              style: { textAlign: 'center' },
              inputMode: 'decimal',
              pattern: '^-?[0-9,]*',
            }}
            startAdornment={<InputAdornment position="start" sx={{ padding: 0.5 }}>R$</InputAdornment>}
            sx={{
              width: { xs: 100, sm: 120 },
              height: 48,
              background: '#F7F7F7',
              fontSize: { xs: '0.95rem', sm: '1rem' },
              fontFamily: 'inherit',
              '& input': {
                padding: 0,
                height: 48,
                boxSizing: 'border-box',
              },
            }}
          />
        </div>
      </td>
      <td>R$ {newMoneyWithNegative.apply(total)}</td>
      <td style={{ textAlign: 'center' }}>
        {isEdited && (
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Tooltip title="Reverter alterações">
              <Button
                variant="outlined"
                color="warning"
                size="small"
                onClick={() => onRollback(element.id)}
                style={{ minWidth: 32, padding: 4, borderRadius: 20 }}
              >
                <UndoIcon fontSize="small" />
              </Button>
            </Tooltip>
          </span>
        )}
      </td>
    </Line>
  );
}

